export default "__VITE_ASSET__DOyEZC_G__"